import axios from "axios";
import consts from "./consts";

axios.defaults.headers.common["Content-Type"] = "application/json";

export const multipart = (url, sender = {}, options = {}) => {
    const dm = consts.api_url;
    console.log(dm + `${url}`);
    return axios.post(dm + `${url}`, sender, options);
};

export const post = (url, sender = {}, withHeader = false) => {
    let dm = consts.api_url;
    console.log(dm + `${url}`);
    if (withHeader) {
        return axios.post(dm + `${url}`, sender, { withCredentials: true });
    } else {
        return axios.post(dm + `${url}`, sender);
    }
};

export const patch = (url, sender = {}, withHeader = false) => {
    let dm = consts.api_url;
    console.log(dm);
    if (withHeader) {
        return axios.patch(dm + `${url}`, sender, { withCredentials: true });
    } else {
        return axios.patch(dm + `${url}`, sender);
    }
}

export const get = (url, sender = {}, withHeader = false) => {
    let dm = consts.api_url;
    const queryString =
        Object.keys(sender).length > 0
            ? '?' +
            Object.entries(sender)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&')
            : '';

    const fullUrl = dm + url + queryString;
    console.log(fullUrl);
    if (withHeader) {
        return axios.get(fullUrl, { withCredentials: true });
    } else {
        return axios.get(fullUrl);
    }
};

export const deleteF = (url, sender = {}) => {
    let dm = consts.api_url;
    return axios.delete(dm + `${url}`, {
        data: sender,
        withCredentials: true
    });
}

export const productPriceList = async () => {
    try {
        // const response = await axiosInstance.get('/productPrice');
        const response = await get('productPrice');
        return response.data;
    } catch (error) {
    }
}

export const xsollaApis = async (apinames="", sender={}) => {
    try {
        // const response = await axiosInstance.get('/productPrice');
        if(!apinames) return;
        const response = await post(apinames, sender);
        return response.data;
    } catch (error) {
    }
}

